export const languages = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Russian',
  'Japanese',
  'Chinese',
  'Korean',
  'Dutch',
  'Polish',
  'Turkish',
  'Arabic',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Czech',
  'Hungarian',
  'Romanian',
  'Ukrainian',
  'Greek',
  'Hebrew',
  'Thai',
  'Hindi',
  'Other',
]
